export {
  default,
  StyledBackground,
  StyledOverlay,
  StyledLoader,
} from './OverlayLoader';
